import React from 'react';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import Button from '@libs/ui/components/button';
import { DefaultModal } from '@libs/ui/components/modals';

interface InitialApplyModalProps {
  isApplying: boolean;
  open: boolean;
  handleClose: VoidFunction;
  onSubmit: VoidFunction;
}

const InitialApplyModal = ({
  open,
  handleClose,
  onSubmit,
  isApplying,
}: InitialApplyModalProps) => {
  const { t } = useTranslation('jobBoard');
  return (
    <DefaultModal
      title={t('applyModal.title')}
      open={open}
      handleClose={handleClose}
      actions={
        <>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            autoFocus
            size="large"
            onClick={onSubmit}
            disabled={isApplying}
          >
            {t('applyModal.apply')}
          </Button>
          <Button
            onClick={handleClose}
            fullWidth
            size="large"
            variant="outlined"
            color="secondary"
          >
            {t('applyModal.cancel')}
          </Button>
        </>
      }
    >
      <Grid spacing={4} direction="column" container>
        <Grid item>{t('applyModal.body')}</Grid>
      </Grid>
    </DefaultModal>
  );
};

export default InitialApplyModal;
